import { AddressType, AppType } from "../../apiResponseHelpers";

export interface ApiUserAlias {
  AliasUsername: string;
  AliasDomain: string;
  AddressUsername: string;
  AddressDomain: string;
  AddressId: string;
  AddressType: AddressType;
  AddressName: string;
  AliasVisibility: string;
  AppAddressType?: AppType;
}

export interface UserAlias {
  aliasUsername: string;
  aliasDomain: string;
  addressUsername: string;
  addressDomain: string;
  addressId: string;
  addressType: AddressType;
  addressName: string;
  aliasVisibility: string;
  appAddressType?: AppType;
}

export function apiUserAliasToUserAlias(apiUserAlias: ApiUserAlias): UserAlias {
  const userAlias: UserAlias = {
    aliasUsername: apiUserAlias.AliasUsername,
    aliasDomain: apiUserAlias.AliasDomain,
    addressUsername: apiUserAlias.AddressUsername,
    addressDomain: apiUserAlias.AddressDomain,
    addressId: apiUserAlias.AddressId,
    addressType: apiUserAlias.AddressType,
    addressName: apiUserAlias.AddressName,
    aliasVisibility: apiUserAlias.AliasVisibility
  };
  if (apiUserAlias.AppAddressType) userAlias.appAddressType = apiUserAlias.AppAddressType;
  return userAlias;
}

export interface AddUserAliasParams {
  AliasUsername: string;
  AddressUsername: string;
  Visibility: "PUBLIC" | "PRIVATE";
}
